import React from "react";
import { generatePath, useHistory } from "react-router-dom";
import useAuthUser from "hooks/useAuthUser";
import JoinLiveChatModal from "components/JoinLiveChatModal";
import { Routes } from "../../router/config";

function GoAppointmentChatModal({ onClose, appointmentId }: { onClose: () => void; appointmentId: string }) {
  const history = useHistory();
  const { user } = useAuthUser();

  const onClickStart = () => {
    history.push(generatePath(Routes.appointmentByAppointmentId, { appointmentId }));
  };

  if (!appointmentId || !user) onClose();

  return <JoinLiveChatModal className={"go-appointment-chat-modal"} onClose={onClose} onSubmit={onClickStart} />;
}

export default GoAppointmentChatModal;
